export default {
  title: '! Bestellingen gepauzeerd tot {{time}}',
  button: 'Hervatten',
  labels: {
    rest_of_day: 'rest van de dag',
  },
};
